import { VariantPricing } from './types'

const getSavingValue = ({ price, rrp }: VariantPricing) => {
  const currencySymbol = price.displayValue.replace(/[0-9\.,]+/g, '')
  const indexOfCurrency = price.displayValue.indexOf(currencySymbol)
  const priceAsNumber = parseFloat(price.amount)
  const rrpAsNumber = parseFloat(rrp.amount)

  if (
    priceAsNumber === rrpAsNumber ||
    priceAsNumber > rrpAsNumber ||
    isNaN(priceAsNumber) ||
    isNaN(rrpAsNumber)
  ) {
    return null
  }

  return {
    indexOfCurrency,
    currencySymbol,
    saving: rrpAsNumber - priceAsNumber,
  }
}

export const getVariantSavingValue = (variant: VariantPricing) => {
  const result = getSavingValue(variant)
  const savingsText = result?.saving.toFixed(2)

  return result && savingsText
    ? `${savingsText.slice(0, result.indexOfCurrency)}${
        result.currencySymbol
      }${savingsText.slice(result.indexOfCurrency)}`
    : null
}

export const getVariantSavingNumber = (variant: VariantPricing) => {
  return getSavingValue(variant)?.saving
}
